import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import messages from '../messages';
import { DeliveryOptionHeader } from './delivery-options-header';
import style from './delivery-options-settings.module.less';

type WooCommerceInvalidContentProps = {
  marketplaceName?: string;
  defaultWarehouseName?: string;
};

export const WooCommerceInvalidContent = ({ marketplaceName, defaultWarehouseName }: WooCommerceInvalidContentProps) => (
  <div className={style['delivery-options-settings']}>
    <div className={style['explanation-and-key']}>
      <Text className={style.title} textType={TextType.H3} value={messages.checkoutRates} />
      <DeliveryOptionHeader defaultWarehouseName={defaultWarehouseName} marketplaceName={marketplaceName} />
    </div>
    <BannerMessageV2 content={<FormattedMessage {...messages.wooCommerceVersionNotSupported} />} status={BannerStatus.Error} />
  </div>
);
